import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from '../../link/link';
import {Body} from '../../typography/body';

type Props = {
    title: string;
    subtitle?: string;
    linkProps?:
        | {
              to: string;
              text: string;
          }
        | null
        | undefined;
};

export function SectionHeader(props: Props) {
    return (
        <div className='flex justify-sb py-8 px-16 background-offwhite-dk'>
            <div className='flex flex-dir-col gap-4'>
                <Body isBold={true}>{props.title}</Body>
                {props.subtitle && (
                    <Body color='light' size='small'>
                        {props.subtitle}
                    </Body>
                )}
            </div>
            {props.linkProps && (
                // @ts-expect-error
                <Link as={RoutedLink} variant='primary' to={props.linkProps.to} size='small'>
                    {props.linkProps.text}
                </Link>
            )}
        </div>
    );
}
